import { baseQuery } from '../baseQuery';
import { JsonDataItem } from 'types';

export const getCheckCustomerMobileNumber = async ({ number, customerType }: JsonDataItem) => {
  const { data } = await baseQuery(
    `check-customer-mobile-number?mobile_number=${number}&customer_type=${customerType}`,
  );

  return data;
};
